var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PeerFileClosedMessage } from "../../../messages/file/FileMessages";
import { MulticastDelegate1, MulticastDelegate3 } from "flavr-common";
import { peerService } from "./PeerService";
import { PeerFile } from "./PeerFile";
export class PeerLocalFile extends PeerFile {
    constructor(fileId, creator, owner) {
        super(fileId);
        this.fileId = fileId;
        this.creator = creator;
        this.owner = owner;
        this.filename = "";
        this.onError = new MulticastDelegate3();
        this.onClosed = new MulticastDelegate1();
    }
    setData(data, url) {
        if (url !== undefined) {
            this.url = url;
        }
        this.data = data;
    }
    getData() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.data;
        });
    }
    send(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (data) {
                this.data = data;
            }
            const promises = [];
            if (!peerService.peerMgr)
                return;
            for (const peer of peerService.peerMgr.peers.values()) {
                if (typeof this.data === "string") {
                    promises.push(peer.webRTC.sendFileString(this.data, {
                        filename: this.filename,
                        fileId: this.fileId,
                        creator: this.creator,
                        owner: this.owner,
                        fileTypeExtension: this.fileTypeExtension
                    }));
                }
                else if (this.data) {
                    promises.push(peer.webRTC.sendFile(this.data, {
                        filename: this.filename,
                        fileId: this.fileId,
                        creator: this.creator,
                        owner: this.owner,
                        type: this.data.type,
                        fileTypeExtension: this.fileTypeExtension
                    }));
                }
            }
            yield Promise.all(promises);
        });
    }
    sendTo(clientId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!peerService.peerMgr)
                return;
            const peer = peerService.peerMgr.getPeer(clientId);
            if (!peer)
                return false;
            if (typeof this.data === "string") {
                yield peer.webRTC.sendFileString(this.data, {
                    filename: this.filename,
                    fileId: this.fileId,
                    creator: this.creator,
                    owner: this.owner
                });
            }
            else {
                yield peer.webRTC.sendFile(this.data, {
                    filename: this.filename,
                    fileId: this.fileId,
                    creator: this.creator,
                    owner: this.owner
                });
            }
            return true;
        });
    }
    close() {
        this.onClosed.invoke(this);
        if (!peerService.peerMgr)
            return;
        peerService.peerMgr.broadcastBusMessage(new PeerFileClosedMessage(this.fileId));
    }
}
